<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="space-between">
        <el-row>
          <el-button
            size="small"
            class="filter-item"
            @click="add"
            type="primary"
            icon="el-icon-plus"
          >
            新增兑换码类型
          </el-button>
        </el-row>
        <el-row type="flex" justify="end">
          <div>
            兑换码标题
            <el-input
              v-model="listQuery.title"
              placeholder="请输入标题"
              style="width: 200px"
              class="filter-item"
              clearable
            />
          </div>
          <div>
            兑换码状态
            <el-select
              v-model="listQuery.is_on"
              placeholder="状态"
              clearable
              style="width: 200px"
              class="filter-item"
            >
              <el-option label="正常" value="1" />
              <el-option label="下架" value="0" />
            </el-select>
          </div>
          <div>
            折扣类型
            <el-select
              v-model="listQuery.value_type"
              placeholder="折扣类型"
              clearable
              style="width: 200px"
              class="filter-item"
            >
              <el-option label="固定金额" value="fixed_amount" />
              <el-option label="百分比" value="percentage" />
            </el-select>
          </div>
          <el-button
            size="small"
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
            >搜索</el-button
          >
        </el-row>
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="70">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="折扣码标题" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.lang?.title ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column label="使用时间从" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.start_at }}
        </template>
      </el-table-column>
      <el-table-column label="到" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.end_at }}
        </template>
      </el-table-column>
      <el-table-column label="所需积分" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.exchange_value }}
        </template>
      </el-table-column>
      <el-table-column label="门槛" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            !scope.row.min_price || scope.row.min_price < 1
              ? '无门槛'
              : `满$${scope.row.min_price}`
          }}
        </template>
      </el-table-column>
      <el-table-column label="兑换码折扣" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.value_type == 'percentage' ? '' : '$'
          }}{{ scope.row.value
          }}{{ scope.row.value_type == 'percentage' ? '%' : '' }}
        </template>
      </el-table-column>
      <el-table-column label="折扣类型" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.value_type == 'fixed_amount' ? '固定金额' : '百分比' }}
        </template>
      </el-table-column>
      <el-table-column label="指定商品" min-width="190" align="center">
        <template slot-scope="scope">
          <span
            v-for="(options_item, index) in scope.row.entitled_product_options"
            :key="index"
            class="option-label"
          >
            {{ options_item.label
            }}<span v-if="index < scope.row.entitled_product_options.length - 1"
              >，</span
            >
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on == '1'" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.is_on == '0'" type="warning"
            >已下架</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="230">
        <template slot-scope="scope">
          <div class="flex flex-jc flex-gap-5 flex-wrap">
            <el-button
              style="flex: 0 0 auto"
              size="mini"
              type="warning"
              @click="edit(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="toDetail(scope.row.id)"
            >
              兑换详情
            </el-button>
            <el-button
              style="flex: 0 0 auto"
              type="primary"
              size="mini"
              @click="changeStatus(scope.row)"
            >
              {{ Number(scope.row.is_on) == 1 ? '下架' : '上架' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        title: '',
        is_on: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  methods: {
    toDetail(id) {
      this.$router.push('/operation/exchangeDetail?id=' + id)
    },
    changeStatus(row) {
      let str
      if (Number(row.is_on) == 1) {
        str = '是否确认下架?'
      } else {
        str = '是否确认上架?'
      }
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/coupon/changeStatus',
            method: 'post',
            data: {
              id: row.id,
              is_on: row.is_on == 1 ? 0 : 1,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/coupon/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    add(val) {
      this.$router.push('/operation/edit')
    },
    edit(val) {
      this.$router.push('/operation/edit?id=' + val.id)
    },
    createuser() {
      this.$router.push('/USER/createuser')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.option-label {
  // white-space: nowrap;
}
</style>
